import { Box, Heading, ListItem, Text, UnorderedList } from "@chakra-ui/react";
import { ReactElement } from "react";

export default function PrivacyPolicyBox(): ReactElement {
  return (
    <Box
      fontFamily="Noto Sans CJK JP"
      fontSize="12px"
      p={2}
      border="1px solid"
      borderColor="gray.300"
      borderRadius="md"
      w="full"
      maxH="150px"
      overflowY="auto"
    >
      <Heading size="sm" textAlign="center">
        ◆プライバシーポリシー
      </Heading>
      <Text fontWeight="bold" mt={2}>
        個人情報の取扱い
      </Text>
      <Text fontWeight="bold" mt={2}>
        個人情報保護方針
      </Text>
      <Text fontWeight="medium">
        当社は、個人情報保護に関する法令および以下に定める基本方針に従い、お客様・お取引関係者様・当社従業員などの個人情報の適切な保護に努めます。
      </Text>
      <Text fontWeight="medium">
        当社は、個人情報の取り扱いに関し、業務に携わるすべての者が遵守すべき社内規程を定め、周知徹底します。
      </Text>
      <Text fontWeight="medium">
        当社は、個人情報の取り扱いに関する統括責任者を設置するとともに、当社の従業者（役員・従業員・パートタイマー・派遣社員等）その他の関係者に対し、教育啓発活動を行います。
      </Text>
      <Text fontWeight="medium">
        当社は、個人情報を適正な手段によって取得します。また取得にあたっては、その利用目的、当社対応窓口などをご本人に個別にお知らせするか、ウェブサイト等の容易に知りうる手段にて公表します。
      </Text>
      <Text fontWeight="medium">
        当社においては、個人情報は、ご本人にお知らせし、または公表した利用目的の範囲内で、その個人情報の取り扱い権限を与えられた者のみが、その取り扱い上必要な範囲内で利用するものとします。
      </Text>
      <Text fontWeight="medium">
        当社は、個人情報を第三者に提供するに当っては、その個人情報のご本人からの同意を得るなど法令上必要な措置を講じます。
      </Text>
      <Text fontWeight="medium">
        当社は、個人情報に関する業務を社外に委託する場合は、適切な業務委託先を選び、必要かつ適切な監督を行うなど、法令上必要な措置を講じます。
      </Text>
      <Text fontWeight="medium">
        当社は、保有する個人データの開示、訂正、利用停止、削除等の求めを受けた場合には、ご本人からの求めであることを確認した上で、法令に従って適切に対応します。
      </Text>
      <Text fontWeight="medium">
        当社は、個人情報への不正アクセス、紛失、破壊、改ざん、漏えい等について予防等の合理的な安全対策を講じ、継続的な改善に努めます。
      </Text>
      <Text fontWeight="medium">マツダ株式会社</Text>
      <Text fontWeight="medium">代表取締役社長兼CEO 毛籠 勝弘</Text>
      <Text fontWeight="bold" mt={2}>
        個人情報の取得と利用について
      </Text>
      <Text fontWeight="medium">
        当社は個人情報を取得する際には、その利用目的を公表または通知し、適法かつ公正な手段によって取得いたします。また、当社が取得いたしました個人情報は、以下の利用目的の達成に必要な場合に限り利用いたします。
      </Text>
      <Text fontWeight="bold" mt={2}>
        利用目的
      </Text>
      <Text fontWeight="medium">
        商品、サービス、企業活動などに関する情報等の提供、お問合せ・ご要望への対応のため。
      </Text>
      <Text fontWeight="medium">
        商品企画、開発、宣伝、販売・サービス活動、品質向上、リコール対応等に利用するため。
      </Text>
      <Text fontWeight="medium">
        商品企画、開発、お客様満足度向上策検討に必要なアンケート調査を実施するため。
      </Text>
      <Text fontWeight="medium">
        各種イベント、コミュニティ活動、親睦活動、キャンペーン等の運営や、これに必要な諸連絡や商品の発送等を行うため。
      </Text>
      <Text fontWeight="medium">
        株主様への、会社法に基づく義務の履行や、各種法令への対応、便宜の供与、または、関係構築を目的とした各種施策実施のため。
      </Text>
      <Text fontWeight="medium">
        お取引先様との、連絡・交渉・契約履行・履行請求、または、関係構築を目的とした各種施策実施のため。
      </Text>
      <Text fontWeight="medium">
        採用選考およびそれに関連する諸手続き、お問合せ・ご要望への対応のため。
      </Text>
      <Text fontWeight="medium">受託業務の遂行のため。</Text>
      <Text fontWeight="medium">
        個人情報保護法その他法令で認められた利用目的の達成のため。
      </Text>
      <Text fontWeight="medium">
        個人情報取得時に明示した利用目的、もしくは、取得後にご本人から同意いただいた利用目的の達成のため。
      </Text>
      <Text fontWeight="medium">
        当社が取得する個人情報とは、音声・画像・映像等の情報を含みます。
      </Text>
      <Text fontWeight="medium">
        当社が取得する個人情報とは、直接的に取得する場合と、関係会社や取引先などから間接的に取得する場合があります。
      </Text>
      <Text fontWeight="bold" mt={2}>
        第三者提供
      </Text>
      <Text fontWeight="medium">
        当社が取得いたしました個人データの第三者への提供につきましては、事前にご本人の同意をいただいた場合を除き行いません。ただし、以下の場合はこの限りではありません。
      </Text>
      <UnorderedList fontWeight="medium" spacing={1} mt={2}>
        <ListItem>
          人の生命、身体または財産の保護のために開示の必要があり、ご本人の同意を得ることが困難である場合
        </ListItem>
        <ListItem>法令により個人情報の開示が求められた場合</ListItem>
        <ListItem>その他法令に定めのある場合</ListItem>
      </UnorderedList>
      <Text fontWeight="bold" mt={2}>
        個人情報の共同利用について
      </Text>
      <Text fontWeight="medium">
        当社は「個人情報の利用と利用目的」に定める利用目的の達成に必要な範囲内において、個人データを共同利用させていただく場合があります。
      </Text>
      <Text fontWeight="bold" mt={2}>
        共同利用する個人データの項目
      </Text>
      <Text fontWeight="medium">
        属性に関する情報（住所、電話番号、メールアドレス、氏名、生年月日、勤務先
        等）
      </Text>
      <Text fontWeight="medium">
        利用サービス・商品に関する情報（販売店などの利用状況、車検証の情報 等）
      </Text>
      <Text fontWeight="bold" mt={2}>
        その他（各種のお問合せ・ご要望・ご相談の内容 等）
      </Text>
      <Text fontWeight="bold" mt={2}>
        共同利用者の範囲
      </Text>
      <Text fontWeight="medium">
        当社とマツダ製品特約販売契約を締結する販売会社、当社の関係会社
      </Text>
      <Text fontWeight="bold" mt={2}>
        共同利用の利用目的
      </Text>
      <Text fontWeight="medium">
        「個人情報の取得と利用について」の項目に記載の利用目的
      </Text>
      <Text fontWeight="bold" mt={2}>
        共同利用する個人データの管理責任者
      </Text>
      <Text fontWeight="medium">マツダ株式会社</Text>
      <Text fontWeight="bold" mt={2}>
        開示等の手続きに関する事項
      </Text>
      <Text fontWeight="medium">
        保有個人データについて、ご本人またはその代理人の方からの利用目的通知・開示・訂正・利用停止等のご請求（以下「開示等のご請求」といいます）の手続き（必要書類、手数料など）につきましては、以下のお問合せ窓口へお問合せください。
      </Text>
      <Text fontWeight="bold" mt={2}>
        お問合せ窓口
      </Text>
      <Text fontWeight="bold" mt={2}>
        個人情報の取扱いに関するお問合せ先
      </Text>
      <Text fontWeight="medium">
        当社の個人情報の取扱いに関するお問合せにつきましては、下記の当社コールセンターまでお申し出ください。
      </Text>
      <Text fontWeight="medium">
        マツダの販売会社へ提供された個人情報につきましては、当該販売会社の個人情報相談窓口へお問合せください。
      </Text>
      <Text fontWeight="medium">
        当社コールセンターにおいては、お話いただきました内容を確認するために録音させていただくとともに、折り返しご連絡させていただく場合のためにナンバーディスプレイを採用しています。
      </Text>
      <Text fontWeight="bold" mt={2}>
        当社ウェブサイトをご利用される際にご提供いただく情報について
      </Text>
      <Text fontWeight="medium">
        当社ウェブサイトをご利用されるにあたり、個人情報をご提供いただく場合があります。この場合、当社はご提供いただいた個人情報を、この「個人情報の取扱い」にしたがい管理いたします。ご提供いただく個人情報とは、ご自身で入力いただく情報に加え、ウェブサイト利用時に収集されるクッキーなどのトラッキング技術情報を含みます。
      </Text>
      <Text fontWeight="bold" mt={2}>
        クッキー（Cookie）の利用について
      </Text>
      <Text fontWeight="medium">
        当社ウェブサイトは、利用者の利便性向上、当社ウェブサイトの改善・品質向上、当社広告配信などを目的として、クッキー利用しています。クッキーは、ウェブページを利用したときに、ブラウザとサーバーとの間で送受信した利用履歴や入力内容などを、利用者のコンピューターにファイルとして保存しておく仕組みで、ご使用のブラウザの設定により、クッキーの受け取りを拒否することが可能です。クッキー自体には、氏名、住所、電話番号といった情報は含まれていませんが、他の個人情報と紐づけた場合、個人を特定できる可能性があります。なお、その場合も、第三者への提供につきましては、事前にご本人の同意をいただいた場合を除き行いません。
      </Text>
      <Text fontWeight="bold" mt={2}>
        その他
      </Text>
      <Text fontWeight="medium">
        「個人情報の取扱い」の内容につきましては、適宜見直しを行い、改訂することがあります。すべての改訂はこのサイトでお知らせいたします。
      </Text>
      <Text fontWeight="medium">
        日本国外からのアクセスの場合、個人情報の取扱いについては日本国の法律に基づきます。
      </Text>
      <Text fontWeight="medium">
        当社ウェブサイトは、他のウェブサイトへリンクしていることがありますが、リンク先のウェブサイトでの個人情報の取扱いについては、当該リンク先に対してご自身でご確認ください。
      </Text>
      <Text fontWeight="medium">
        マツダ病院で取得いたしました個人情報の利用目的・開示等のご請求・お問合せにつきましては、マツダ病院ホームページの「個人情報の取扱い」をご覧ください。
      </Text>
      <Text fontWeight="medium" mt={2}>
        2025年8月18日
      </Text>
    </Box>
  );
}
